import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SubmitSalesPortalOrderDocument = gql`
  mutation SubmitSalesPortalOrder(
    $orderUUID: uuid!
    $orderNotes: String
    $poNumber: String
    $additionalInputValues: [AdditionalInputValueInput!]!
  ) {
    submitOrder(
      additional_input_values: $additionalInputValues
      order_id: $orderUUID
      order_notes: $orderNotes
      po_number: $poNumber
    ) {
      order_id
    }
  }
`;
export type SubmitSalesPortalOrderMutationFn = Apollo.MutationFunction<
  Types.SubmitSalesPortalOrderMutation,
  Types.SubmitSalesPortalOrderMutationVariables
>;
export function useSubmitSalesPortalOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SubmitSalesPortalOrderMutation,
    Types.SubmitSalesPortalOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SubmitSalesPortalOrderMutation,
    Types.SubmitSalesPortalOrderMutationVariables
  >(SubmitSalesPortalOrderDocument, options);
}
export type SubmitSalesPortalOrderMutationHookResult = ReturnType<
  typeof useSubmitSalesPortalOrderMutation
>;
export type SubmitSalesPortalOrderMutationResult =
  Apollo.MutationResult<Types.SubmitSalesPortalOrderMutation>;
export type SubmitSalesPortalOrderMutationOptions = Apollo.BaseMutationOptions<
  Types.SubmitSalesPortalOrderMutation,
  Types.SubmitSalesPortalOrderMutationVariables
>;
